import React, { useState } from "react";
import "../../../../css/Common/Components/Cards/CardContactOptions.css";
import "../../../../css/App.css";

/**
 * CardContactOptions component renders a contact option card with an icon, title, and contact information.
 * Handles different contact actions such as call, email, or callback based on the provided type.
 * @returns {JSX.Element} The rendered CardContactOptions component.
 */
const CardContactOptions = ({
  title,
  icon: Icon,
  contactInfo = "",
  onClickType,
  onOpenCallback = null,
  isAdviser = false,
}) => {
  const [clicked, setClicked] = useState(false);

  /**
   * Handles click events for different contact options.
   *
   * Depending on the value of `onClickType`, this function will:
   * - Initiate a phone call by redirecting to a `tel:` link if `onClickType` is "call".
   * - Open the default email client by redirecting to a `mailto:` link if `onClickType` is "email".
   * - Trigger a callback function if `onClickType` is "callback".
   * 
   * In all cases except the default, toggles the `clicked` state.
   *
   * @function
   * @returns {void}
   */
  const handleOnClick = () => {
    switch (onClickType) {
      case "call":
        setClicked(!clicked);
        window.location.href = `tel:${contactInfo}`;
        break;
      case "email":
        setClicked(!clicked);
        window.location.href = `mailto:${contactInfo}`;
        break;
      case "callback":
        setClicked(!clicked);
        if (onOpenCallback) onOpenCallback();
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={`Card-Contact-Option ${isAdviser ? "Adviser" : ""}  ${
        clicked ? "clicked" : ""
      }`}
      onClick={handleOnClick}
    >
      {Icon && <Icon className="ContactUs-Icon" />}
      <div className="Button-Text-Medium">{title}</div>
      {contactInfo && <div className="Button-Text-Medium">{contactInfo}</div>}
    </div>
  );
};

export default CardContactOptions;
